import moment from "moment";
import { clamp } from "@bonliva-crm/common";
import locale from "@bonliva-crm/locale";

export function dateToValue(
  date: Date | null,
  days: number,
  lastDay: moment.Moment,
  position: "start" | "end"
) {
  if (date === null) {
    return position === "start" ? 0 : days;
  }

  const result = days - moment(lastDay).diff(date, "days");
  return clamp(result, 0, days);
}

export function pickerDateToDate(
  date: moment.Moment,
  lastDay: moment.Moment,
  days: number
) {
  const value = days - lastDay.diff(date, "days");
  return valueToDate(value, lastDay, days);
}

export function valueToMoment(value: number, lastDay: moment.Moment, days: number) {
  if (value <= 0 || value >= days) {
    return null;
  }

  return moment(lastDay).subtract(days - value, "d");
}

export function valueToDate(value: number, lastDay: moment.Moment, days: number) {
  const m = valueToMoment(value, lastDay, days);
  return m ? m.toDate() : null;
}

export function valueToDateString(
  value: number,
  lastDay: moment.Moment,
  days: number,
  type: "start" | "end",
  momentToString: (v: moment.Moment) => string
) {
  const date = valueToMoment(value, lastDay, days);

  if (!date && type === "end") {
    return momentToString(moment());
  }

  if (!date && type === "start") {
    return locale.Never.toLocaleLowerCase();
  }

  return momentToString(date);
}
